const boardTypes = Object.freeze({
  'VENDA': 'VENDA',
  'COBRANCA': 'COBRANCA',
  'OPERACAO': 'OPERACAO',
  'AJUIZAMENTO': 'AJUIZAMENTO'
})

export default boardTypes



// WEBPACK FOOTER //
// ./src/enums/enumBoardTypes.js